import type { ReactElement, ReactNode } from 'react';
import { useEffect } from 'react';

import { Component as WarningIcon } from 'icons/icon-circle--warning.svg';

import HeapAnalytics from 'services/HeapAnalytics';
import { HeapCustomEvent } from 'config';

import { AlertType } from 'models/Alert';

type Props = {
  type?: AlertType;
  heapEvent?: HeapCustomEvent;
  children: ReactNode;
};

function Alert({
  type = AlertType.ERROR,
  heapEvent,
  children,
}: Props): ReactElement {
  useEffect(() => {
    if (heapEvent) {
      HeapAnalytics.track(heapEvent);
    }
  }, [heapEvent]);

  return (
    <div
      className={[
        'c-meal-management-alert',
        `c-meal-management-alert--${type}`,
      ].join(' ')}
    >
      <WarningIcon height="17" />
      &nbsp;
      {children}
    </div>
  );
}

export default Alert;
